import React from 'react';

import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';
import Text from '@amzn/meridian/text';

import { UamOverviewTable } from '../../../features/UamOverviewTable/UamOverviewTable';

export const Uam: React.VFC = () => {
    return (
        <Column spacingInset='400'>
            <Heading level={1}>Unusual Activity Message</Heading>
            <Text type='b200' color='secondary'>
                Manage titles flagged with unusual voting activity. Click a row to view audit history.
            </Text>
            <UamOverviewTable />
        </Column>
    );
};
